import React from "react";
import { useIntl } from "react-intl";
import { Bell, ShieldCheck } from "lucide-react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "components/ui/card";
import ChangePasswordForm from "./ChangePasswordForm";
import MessagingEmailAlertsForm from "./MessagingEmailAlertsForm";

const Settings: React.FC = () => {
    const intl = useIntl();

    return (
        <div className="flex flex-col gap-6">
            <Card variant="muted" className="rounded-2xl shadow-sm">
                <CardHeader className="flex-row items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-50 text-primary">
                        <ShieldCheck className="h-5 w-5" aria-hidden />
                    </div>
                    <div>
                        <CardTitle asChild className="text-xl font-bold text-slate-900">
                            <h2>{intl.formatMessage({ id: "profile.settings.security.title" })}</h2>
                        </CardTitle>
                        <CardDescription className="text-sm text-slate-500">
                            {intl.formatMessage({ id: "profile.settings.security.password.subtitle" })}
                        </CardDescription>
                    </div>
                </CardHeader>
                <CardContent className="max-w-2xl">
                    <ChangePasswordForm />
                </CardContent>
            </Card>

            <Card variant="muted" className="rounded-2xl shadow-sm">
                <CardHeader className="flex-row items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-50 text-primary">
                        <Bell className="h-5 w-5" aria-hidden />
                    </div>
                    <div>
                        <CardTitle asChild className="text-xl font-bold text-slate-900">
                            <h2>{intl.formatMessage({ id: "profile.settings.notifications.title" })}</h2>
                        </CardTitle>
                        <CardDescription className="text-sm text-slate-500">
                            {intl.formatMessage({ id: "profile.settings.notifications.subtitle" })}
                        </CardDescription>
                    </div>
                </CardHeader>
                <CardContent className="max-w-2xl">
                    <MessagingEmailAlertsForm />
                </CardContent>
            </Card>
        </div>
    );
};

export default Settings;
